import type { ErrorComponentProps } from '@tanstack/react-router'
import { useState } from 'react'

export function ErrorPage({ error, reset }: ErrorComponentProps) {
  const [showDetail, setShowDetail] = useState(false)
  const message = error instanceof Error ? error.message : 'Terjadi kesalahan yang tidak diketahui'

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '2rem',
      }}
    >
      <div style={{ textAlign: 'center', maxWidth: 500 }}>
        <div style={{ fontSize: 64, marginBottom: 16 }}>⚠️</div>
        <h2 style={{ margin: '0 0 8px' }}>Terjadi Kesalahan</h2>
        <p style={{ color: 'var(--mantine-color-dimmed)', margin: '0 0 24px' }}>
          Maaf, terjadi kesalahan saat memuat halaman ini. Silakan coba lagi atau kembali ke halaman sebelumnya.
        </p>
        <div style={{ display: 'flex', gap: 8, justifyContent: 'center', marginBottom: 16 }}>
          <button
            type="button"
            onClick={() => window.history.back()}
            style={{
              padding: '8px 16px',
              border: '1px solid var(--mantine-color-default-border)',
              borderRadius: 6,
              background: 'var(--mantine-color-default)',
              color: 'inherit',
              cursor: 'pointer',
            }}
          >
            ← Kembali
          </button>
          <button
            type="button"
            onClick={reset}
            style={{
              padding: '8px 16px',
              border: 'none',
              borderRadius: 6,
              background: 'var(--mantine-primary-color-filled)',
              color: 'white',
              cursor: 'pointer',
            }}
          >
            ↻ Coba Lagi
          </button>
        </div>
        <button
          type="button"
          onClick={() => setShowDetail((v) => !v)}
          style={{
            background: 'none',
            border: 'none',
            color: 'var(--mantine-color-dimmed)',
            textDecoration: 'underline',
            cursor: 'pointer',
            fontSize: 12,
          }}
        >
          {showDetail ? 'Sembunyikan' : 'Tampilkan'} detail error
        </button>
        {showDetail && (
          <pre
            style={{
              marginTop: 12,
              padding: 12,
              background: 'var(--mantine-color-dark-7, #1a1a2e)',
              borderRadius: 6,
              fontSize: 12,
              textAlign: 'left',
              overflow: 'auto',
              whiteSpace: 'pre-wrap',
              wordBreak: 'break-word',
            }}
          >
            {message}
            {error instanceof Error && error.stack ? `\n\n${error.stack}` : ''}
          </pre>
        )}
      </div>
    </div>
  )
}
